import { Position } from "./position";
import { Rotation } from "./rotation";

export class AccessorySaveData {

  constructor(public id: string,
              public name: string,
              public position: Position,
              public rotation: Rotation,
              public parentId: number) {
  }
}



// WEBPACK FOOTER //
// ./src/app/classes/accessory-save-data.ts